import { format } from 'date-fns';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

interface OverviewHeaderActionsProps {
	loadedAt: Date | null;
	isFetching: boolean;
	onRefresh: () => void;
}

export default function OverviewHeaderActions({
	loadedAt,
	isFetching,
	onRefresh,
}: OverviewHeaderActionsProps) {
	const displayTime = loadedAt ? format(loadedAt, 'HH:mm') : '—';

	return (
		<div className="flex items-center gap-3">
			<span className="text-sm text-raro-gray-600">
				Dados de {displayTime}
			</span>
			<button
				onClick={onRefresh}
				disabled={isFetching}
				className="p-2 hover:bg-raro-gray-100 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition"
				title="Atualizar dados"
				data-tour="overview-refresh"
			>
				<ArrowPathIcon className={`w-4 h-4 ${isFetching ? 'animate-spin' : ''}`} />
			</button>
		</div>
	);
}
